
const Footer = () => {

    return (  
        <div className="bg-black dark:bg-inherit w-full flex items-center justify-center h-24">
            <div className="text-white text-center ">
                <p className='text-[#60A5FA] font-extrabold text-lg lg:text-xl'>
                    &lt;/<span className='text-white'>drix</span>&gt;
                </p>
                <p className="text-xs uppercase py-0.5">2023 DESIGNED BY CHRISTIAN JOSEPH DIMLA. © ALL RIGHT RESERVED.</p>
            </div>
        </div>
    );
}
 
export default Footer;